// ProtectedRoute.tsx 
import React, { useEffect } from "react";
import { Route, Redirect,RouteProps } from "react-router-dom";
import { Cookie } from "../../base/utils";
import jwt_decode from "jwt-decode";

// We are taking in the component that should be rendered if the user is authed
// We are also passing the rest of the props to the <Route /> component such as
// exact & the path

interface PrivateRouteProps extends RouteProps {
    // tslint:disable-next-line:no-any
    component?: any;
    // tslint:disable-next-line:no-any
    children?: any;
    fakeAuth?:any;
  }
const ProtectedRoute = (props: PrivateRouteProps) => {
    // Getting the value from our cool custom hook
  const { component: Component, children, fakeAuth, ...rest } = props;
  const token:any =  Cookie.get();
  const ssoToken =  token["ssoToken"] ?? '';
  const decodedToken: any = ssoToken && jwt_decode(ssoToken);
  useEffect(()=>{
   if(!token){
    window.location.reload();
  } else if (decodedToken?.is_ucas_user !== 1){
    Cookie.deleteKey("ssoToken")
  }
},[token["ssoToken"]]);

  return (
    <Route
      {...rest}
      render={routeProps =>
        token && token["ssoToken"] && decodedToken?.is_ucas_user === 1 ? (
          Component ? (
            <Component {...routeProps} />
          ) : (
            children
          )
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: routeProps.location }
            }}/>
        )
      }
    />
  );
};

export default ProtectedRoute;